import { Box, DialogTitle, IconButton, Tooltip, Typography } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { type MouseEvent } from 'react';
import { formatSourceColor } from 'src/utils/devices';
import { type Device } from '@features/createDeviceConfiguration/graphql/querys/getUpdateHardwareConfigurationData';

interface HeaderConfigDeviceProps {
  device: Device;
  onHistoryClick?: (event: MouseEvent<HTMLElement>) => void;
  historyOpen?: boolean;
}

const HeaderConfigDevice = ({ device, onHistoryClick, historyOpen }: HeaderConfigDeviceProps) => {
  const typeColor = formatSourceColor(device?.profile);
  const dateString = new Date(device?.profile?.created).toLocaleDateString();
  return (
    <DialogTitle sx={{ backgroundColor: '#2a3542' }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Typography variant="h5">{device?.profile?.name}</Typography>
          <Typography>-</Typography>
          <Typography>
            ID <b>{device?.id}</b>
          </Typography>
          <Typography>-</Typography>
          <Typography color={typeColor.color}>
            <b>{device?.profile?.type}</b>
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <Box>
            <Typography align="right">
              Organización: <b>{device?.profile.organization?.name}</b>
            </Typography>
            <Typography align="right">
              Creación: <b>{dateString}</b>
            </Typography>
          </Box>
          {onHistoryClick && (
            <Tooltip title={historyOpen ? 'Ocultar historial' : 'Ver historial de versiones'}>
              <IconButton
                onClick={onHistoryClick}
                size="small"
                color={historyOpen ? 'primary' : 'default'}
                sx={{ mt: 0.5 }}
              >
                <HistoryIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>
    </DialogTitle>
  );
};

export default HeaderConfigDevice;
